var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"section small"},[_c('div',{staticClass:"container"},[(
        _vm.$store.state.auth.user && _vm.$store.state.auth.user.roles.length !== 0
      )?_c('section',{staticClass:"section"},[_c('Section')],1):_vm._e(),_c('section',{staticClass:"section small"},[_c('Roles')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }